import { action, computed, makeObservable, observable } from 'mobx';

import { injectable } from '@servicetitan/react-ioc';

import { compareSemver } from '../utils/compare-semver';

@injectable()
export class AppSettingsStore {
    @observable openedFromCordova = false;
    @observable fmaAppVersion = '0.0.0';

    constructor() {
        makeObservable(this);
    }

    @action
    setOpenedFromCordova = (openedFromCordova: boolean) => {
        this.openedFromCordova = openedFromCordova;
    };

    @action
    setFmaAppVersion = (version: string) => {
        this.fmaAppVersion = version;
    };

    @computed
    get canShowViewButtons() {
        return this.openedFromCordova || compareSemver(this.fmaAppVersion, '17.0.0', false) >= 0;
    }
}
